import { render, staticRenderFns } from "./RejectSurvey.vue?vue&type=template&id=138b5d77&scoped=true&"
import script from "./RejectSurvey.vue?vue&type=script&lang=js&"
export * from "./RejectSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b5d77",
  null
  
)

export default component.exports